module.exports = __webpack_public_path__ + "media/img/description/description-services-after-687a4d283f1aae38f7bd6b8c0f904a12.svg";